import type { TFunction } from 'i18next'

interface Rec {
  priority: number
  action: string
  before?: string
  after?: string
}

export function RecommendationCards({ recs, t }: { recs: Rec[]; t: TFunction }) {
  return (
    <div className="space-y-2">
      {recs.map((r, i) => (
        <div key={i} className="bg-white dark:bg-neutral-800 rounded-xl border border-neutral-200 dark:border-neutral-700 p-4">
          <div className="flex items-center gap-2 mb-1">
            <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400">
              #{r.priority}
            </span>
            <span className="text-sm font-medium text-neutral-900 dark:text-white">{r.action}</span>
          </div>
          {r.before && (
            <div className="mt-2">
              <span className="text-xs font-medium text-neutral-500 dark:text-neutral-400 mb-1 block">
                {t('amazonListing.report.currentState')}
              </span>
              <div className="bg-neutral-50 dark:bg-neutral-700/50 rounded-lg p-3 text-xs text-neutral-700 dark:text-neutral-300 leading-relaxed">
                {r.before}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
